import { Component, ElementRef, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';



@Component({
  selector: 'formly-field-file',
  template: `
    <div class = "my-2">
      <label>{{ to.label }}</label><br>
      <input type="file" formlyAttributes="field" (change)="onFileChange($event)">
    </div>
  `,
})
export class FormlyFieldFile extends FieldType {
  @ViewChild('fileInput') fileInput!: ElementRef;

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.formControl.setValue(file);  // manually update the form control value with the file
    }
  }
}
